export const GET_GAMES_PENDING = 'GET_GAMES_PENDING';
export const GET_GAME_LEAD_PENDING = 'GET_GAME_LEAD_PENDING';
export const GAMES = 'GAMES';
export const GAME_LEADS = 'GAME_LEADS';
export const EXPORT_GAME_LEADS_PENDING = 'EXPORT_GAME_LEADS_PENDING';
export const UPDATE_GAME_PENDING = 'UPDATE_GAME_PENDING';
export const CREATE_GAME_PENDING = 'CREATE_GAME_PENDING';
